import classNames from 'classnames';
import {calculateExpireTime} from 'utilities/helper/expireTime';
import {gradeConvertor} from '../subCardSwitcher/uitilities';
import BadgeSwitcher from '../badgeSwicher';
import {textLengthLimiter} from '../helper';

interface AuctionMainCardProps {
  title: string;
  image: string;
  createdDate: string;
  proposal: number;
  soldTime: string;
  wrapperClassName?: string;
  isExpired: boolean;
  isSold: boolean;
  homeCards?: boolean;
  grade?: string;
  is_distinguished : boolean | undefined
}
const AuctionCard = ({
  title,
  image,
  createdDate,
  proposal,
  soldTime,
  wrapperClassName,
  isExpired,
  isSold,
  homeCards,
  grade,
  is_distinguished
}: AuctionMainCardProps) => {
  const {daysRemain, hoursRemain} = calculateExpireTime(soldTime);
  return (
    <>
      <div
        className={classNames(
          'flex justify-between rounded-lg mx-2 h-[144px] px-2   w-72 ',
          homeCards
            ? 'h-36 shadow-md  !py-2'
            : `${wrapperClassName} h-40 shadow-card`,
           is_distinguished  ? " bg-destinguished-bg border border-solid border-destinguished " : "bg-white"
        )}
      >
        <div className="relative flex items-center !w-[128px] h-full">
          <div
            className={classNames(
              ' absolute  right-1 text-xs text-created-day   px-2 rounded-3xl',
              {'top-4': !homeCards},
              {'top-[10px]': homeCards},
            )}
          >
            <BadgeSwitcher
              createdDate={createdDate}
              isExpired={isExpired}
              isSold={isSold}
            />
          </div>
          <img
            className={classNames(
              'object-cover  rounded-lg flex-none w-[128px] h-[128px]',
              homeCards && ' !w-[110px]',
            )}
            src={image}
            alt={title}
          />
        </div>
        <div className=" flex flex-col grow pl-2 justify-between gap-4 h-full w-[55%]">
          <div className="flex flex-col grow px-2 py-1 gap-2 h-full justify-between">
            <div className="flex w-full mt-2 justify-between">
              <p
                className={classNames(
                  ' text-black  text-sm font-extrabold text-start w-[80%] break-words !max-w-[154px]',
                  {'!max-w-[114px]': homeCards},
                )}
              >
                {textLengthLimiter(title, 20)}
              </p>
              {grade && (
                <span className="w-[23px]">
                  {gradeConvertor[Number(grade)]}
                </span>
              )}
            </div>
            <div className="h-[50%] flex flex-col  justify-end">
              <div className="flex items-center h-[45%]">
                <span className="icon-auction-card ml-1 text-sm text-primary"></span>
                <p className=" text-sm text-gray-6 ">
                  {proposal.toLocaleString()} پیشنهاد
                </p>
              </div>
              <div className="flex items-center h-[45%] justify-between">
                <div className="flex">
                  <span className="icon-clock text-red-1 ml-1 h-full" />
                  <p className="font-normal text-xs text-red-1 h-full items-center flex gap-1">
                    <span>{daysRemain}روز</span>
                    <span>{hoursRemain}ساعت مانده</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AuctionCard;
